import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function About() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="page about-page">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Sobre a <span className="text-[#2F5496]">Prata Consultoria</span>
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Somos uma empresa especializada em soluções tecnológicas inovadoras, dedicada a transformar ideias em realidade digital com excelência e comprometimento.
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Nossa Missão</h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Democratizar o acesso à tecnologia de ponta, oferecendo soluções personalizadas que impulsionam o crescimento sustentável de nossos clientes através da inovação digital.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Acreditamos que a tecnologia deve ser um facilitador, não um obstáculo. Por isso, desenvolvemos soluções intuitivas, escaláveis e alinhadas com os objetivos estratégicos de cada negócio.
            </p>
          </div>
          <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-8 rounded-2xl relative overflow-hidden">
            {/* Additional background effects */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-100/30 to-indigo-100/30"></div>
            <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmM2Y0ZjYiIGZpbGwtb3BhY2l0eT0iMC4yIj48Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIyIi8+PC9nPjwvZz48L3N2Zz4=')] opacity-50"></div>
            <div className="grid grid-cols-2 gap-6 relative z-10">
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-bold text-[#2F5496] mb-2">2022</div>
                <div className="text-sm text-gray-600">Fundação da empresa</div>
              </div>
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-bold text-[#2F5496] mb-2">100%</div>
                <div className="text-sm text-gray-600">Dedicação total</div>
              </div>
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-bold text-[#2F5496] mb-2">24/7</div>
                <div className="text-sm text-gray-600">Disponibilidade</div>
              </div>
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-bold text-[#2F5496] mb-2">∞</div>
                <div className="text-sm text-gray-600">Potencial</div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute top-4 left-4 w-8 h-8 bg-blue-300 rounded-full animate-bounce opacity-70"></div>
            <div className="absolute bottom-4 left-8 w-4 h-4 bg-indigo-300 rounded-full animate-pulse opacity-80"></div>
            <div className="absolute top-1/2 right-4 w-6 h-6 bg-blue-200 rounded-full animate-ping opacity-60"></div>
          </div>
        </div>
      </div>


      {/* Values Section */}
      <div className="bg-gray-50 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Nossos Valores</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Os princípios que guiam cada decisão e cada projeto que realizamos.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-8 h-8 text-blue-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">Inovação</h3>
              <p className="text-gray-600 leading-relaxed">
                Sempre buscamos as tecnologias mais avançadas e metodologias inovadoras para entregar soluções que superam expectativas.
              </p>
              <div className="mt-4 w-12 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
            </div>

            <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-8 h-8 text-green-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900 group-hover:text-green-600 transition-colors duration-300">Qualidade</h3>
              <p className="text-gray-600 leading-relaxed">
                Comprometemo-nos com a excelência em cada detalhe, garantindo que nossos projetos atendam aos mais altos padrões de qualidade.
              </p>
              <div className="mt-4 w-12 h-1 bg-gradient-to-r from-green-400 to-green-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
            </div>

            <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-8 h-8 text-purple-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900 group-hover:text-purple-600 transition-colors duration-300">Parceria</h3>
              <p className="text-gray-600 leading-relaxed">
                Construímos relacionamentos duradouros baseados na confiança, transparência e compromisso com o sucesso de nossos clientes.
              </p>
              <div className="mt-4 w-12 h-1 bg-gradient-to-r from-purple-400 to-purple-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
            </div>
          </div>
        </div>
      </div>

      {/*/!* Company Info Section *!/*/}
      {/*<div className="container mx-auto px-4 py-20">*/}
      {/*  <div className="text-center mb-16">*/}
      {/*    <h2 className="text-4xl font-bold text-gray-900 mb-6">Informações da Empresa</h2>*/}
      {/*    <p className="text-xl text-gray-600 max-w-3xl mx-auto">*/}
      {/*      Dados oficiais e informações legais da Prata Consultoria em Tecnologia da Informação LTDA.*/}
      {/*    </p>*/}
      {/*  </div>*/}

      {/*  <div className="max-w-4xl mx-auto">*/}
      {/*    <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">*/}
      {/*      <div className="grid md:grid-cols-2 gap-8">*/}
      {/*        <div className="space-y-6">*/}
      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-[#2F5496] to-[#1e40af] rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">🏢</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">Razão Social</h3>*/}
      {/*              <p className="text-gray-600">Prata Consultoria em Tecnologia da Informação LTDA</p>*/}
      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">📋</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">CNPJ</h3>*/}
      {/*              <p className="text-gray-600 font-mono">48.889.573/0001-44</p>*/}
      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">📍</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">Endereço</h3>*/}
      {/*              <p className="text-gray-600">*/}
      {/*                Monte Cambirela, 228 - Sala 03<br />*/}
      {/*                Praia de Fora<br />*/}
      {/*                Palhoça - SC, 88138-700*/}
      {/*              </p>*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </div>*/}

      {/*        <div className="space-y-6">*/}
      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">📧</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">Email</h3>*/}
      {/*              <p className="text-gray-600">ceo@prata.dev.br</p>*/}
      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">📱</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">Telefone</h3>*/}
      {/*              <p className="text-gray-600">(48) 98444-8798</p>*/}
      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className="flex items-center">*/}
      {/*            <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center mr-4">*/}
      {/*              <span className="text-white font-bold text-lg">🏛️</span>*/}
      {/*            </div>*/}
      {/*            <div>*/}
      {/*              <h3 className="text-lg font-bold text-gray-900">Natureza Jurídica</h3>*/}
      {/*              <p className="text-gray-600">Sociedade Empresária Limitada</p>*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className="mt-8 pt-8 border-t border-gray-200">*/}
      {/*        <div className="text-center">*/}
      {/*          <p className="text-gray-500 text-sm">*/}
      {/*            Empresa registrada e em conformidade com todas as legislações vigentes no Brasil.*/}
      {/*          </p>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/* Team Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Nossa Equipe</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contamos com especialistas altamente qualificados e apaixonados por tecnologia, prontos para enfrentar os desafios mais complexos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full mx-auto mb-6 flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-lg">
              <span className="text-2xl font-bold text-white group-hover:scale-110 transition-transform duration-300">DC</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">Desenvolvedores</h3>
            <p className="text-gray-600 mb-4">Especialistas em Full-Stack</p>
            <p className="text-sm text-gray-500">
              Nossa equipe de desenvolvimento possui vasta experiência em tecnologias modernas e metodologias ágeis.
            </p>
            <div className="mt-4 w-8 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto rounded-full group-hover:w-16 transition-all duration-300"></div>
          </div>

          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full mx-auto mb-6 flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-lg">
              <span className="text-2xl font-bold text-white group-hover:scale-110 transition-transform duration-300">UI/UX</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-green-600 transition-colors duration-300">Designers</h3>
            <p className="text-gray-600 mb-4">Especialistas em Experiência do Usuário</p>
            <p className="text-sm text-gray-500">
              Criamos interfaces intuitivas e experiências digitais memoráveis que conectam marcas e usuários.
            </p>
            <div className="mt-4 w-8 h-1 bg-gradient-to-r from-green-400 to-green-600 mx-auto rounded-full group-hover:w-16 transition-all duration-300"></div>
          </div>

          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-24 h-24 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full mx-auto mb-6 flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-lg">
              <span className="text-2xl font-bold text-white group-hover:scale-110 transition-transform duration-300">CS</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-purple-600 transition-colors duration-300">Consultores</h3>
            <p className="text-gray-600 mb-4">Especialistas em Estratégia</p>
            <p className="text-sm text-gray-500">
              Desenvolvemos estratégias tecnológicas alinhadas com os objetivos de negócio de nossos clientes.
            </p>
            <div className="mt-4 w-8 h-1 bg-gradient-to-r from-purple-400 to-purple-600 mx-auto rounded-full group-hover:w-16 transition-all duration-300"></div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-br from-[#2F5496] via-[#1e40af] to-[#1e3a8a] py-20 relative overflow-hidden">
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-4xl font-bold text-white mb-6 transform hover:scale-105 transition-transform duration-300">
            Pronto para Trabalhar Conosco?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed">
            Conheça nossa equipe e descubra como podemos transformar sua visão em uma solução tecnológica de sucesso.
          </p>
          <Link to="/quote" className="inline-block bg-white text-[#2F5496] font-bold text-lg px-8 py-4 rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-xl animate-bounce hover:animate-none">
            Vamos Conversar
          </Link>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-white opacity-10 rounded-full animate-ping"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-white opacity-10 rounded-full animate-pulse"></div>
        <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-white opacity-5 rounded-full animate-bounce"></div>
        <div className="absolute top-1/3 right-1/4 w-12 h-12 bg-white opacity-5 rounded-full animate-pulse"></div>
      </div>
    </div>
  )
}

export default About

